var exports = {
  "i": "x61f99309--db90df--image-container",
  "_": "x61f99309--db90df--img",
};

module.exports = exports;
